import { useGetUiBrandingQuery } from '@energy-stacks/broker/feature-settings-data';
import { ESApexChart, ESApexChartProps } from '@energy-stacks/shared';

interface BrokerApexChartProps extends ESApexChartProps {}

export function BrokerApexChart({ chartData }: BrokerApexChartProps) {
  const { data: uiBranding } = useGetUiBrandingQuery();

  return (
    <ESApexChart
      sx={{
        '.apexcharts-tooltip': {
          borderRadius: uiBranding?.hasBorderRadius ? 2 : 0,
        },
      }}
      chartData={chartData}
    />
  );
}
